module.exports = __webpack_public_path__ + "img/rebuild_yeh_pc4.e97af00c.jpg";